<template>
    <div class="mobile-header md-primary">
        <div class="nav-logo"><img @click="toPage(namespace.PAGE.HOME.id)" src="../../assets/logo-long.png"/></div>

<!--        <md-menu class="page-menu nav-lang md-disabled" md-size="medium" md-align-trigger>-->
<!--            <div  md-menu-trigger>-->
<!--                <img v-if="'EN' === lang" class="icon" src="../../assets/lang-en.png">-->
<!--                <img v-else class="icon" src="../../assets/lang-zh.png">-->
<!--            </div>-->

<!--            <md-menu-content class="help-menu-content">-->
<!--                <md-menu-item @click="changeLang('zh')"><span class="help-text"><img src="../../assets/lang-zh.png" class="icon">ZH</span></md-menu-item>-->
<!--                <md-menu-item @click="changeLang('en')"><span class="help-text"><img src="../../assets/lang-en.png" class="icon">EN</span></md-menu-item>-->
<!--            </md-menu-content>-->
<!--        </md-menu>-->

        <md-menu class="page-menu md-disabled" md-size="medium" md-align-trigger>
            <md-button class="md-icon-button md-primary" md-menu-trigger>
                <img class="menu-arrow-down" src="../../assets/icon-menu.svg">
            </md-button>

            <md-menu-content class="help-menu-content">
                <md-menu-item  v-for="(w, idx) in this.namespace.PAGE.ORDERED" :key="idx"
                               @click="toPage(w.id)">
                    <span class="help-text">{{$t(w.navI18n)}}</span>
                </md-menu-item>
            </md-menu-content>
        </md-menu>
    </div>
</template>

<script>
  import {scNamespace} from "../../js/scNamespace"
  import {toPage, changeLang, lang} from "../../js/common"

  export default {
    name: "nav-header-mobile",
    data() {
      return {
        namespace: scNamespace,
        searchInput: '',
      }
    },
    computed: {
      lang: lang,
    },
    methods: {
      toPage: toPage,
      changeLang: changeLang,
    }
  }
</script>

<style scoped>
    @media screen and (min-width: 960px){
        .mobile-header {
            display: none;
        }
    }

    .mobile-header {
        height: 42px;
        width: 100%;
        min-height: auto;
        border-bottom: 1px solid #eee;
        background-color: #fff;
        z-index: 20000;
    }

    .mobile-header .nav-logo {
        float: left;
        height: 42px;
        line-height: 42px;
        padding-left: 20px;
    }

    .mobile-header .nav-logo > img {
        height: 24px;
    }

    .page-menu {
        float: right;
        margin-right: 20px;
    }

    .page-menu.nav-lang {
        height: 40px;
        line-height: 40px;
    }

    .page-menu.nav-lang span {
        display: inline-block;
        margin-top: 2px;
    }

    .page-menu.nav-lang img.icon {
        width: 20px;
        margin-left: 4px;
        margin-top: -4px;
    }

    .help-menu-content img.icon {
        width: 14px;
        margin: 0 6px;
        margin-top: -4px;
    }
</style>

<style>
    .md-menu-content {
        width: auto !important;
        min-width: auto !important;
        margin-left: 0;
        z-index: 20000 !important;
        box-shadow: 0 2px 2px -2px rgba(0,0,0,.1), 0 4px 10px 1px rgba(0,0,0,.07), 0 1px 7px 1px rgba(0,0,0,.06) !important;
    }
    .md-menu-content .md-menu-content-container {
        background-color: transparent;
    }
    .md-menu-content .md-menu-content-container ul {
        padding: 0;
        border-radius: 4px !important;
    }
    .md-menu-content .md-menu-item .md-list-item-content {
        font-size: 14px;
        padding: 6px 20px;
        height: auto;
        min-height: auto;
        width: auto;
        min-width: auto;
        color: #333333;
    }
</style>